/**
* Created by bieao on 2020/4/2.
*/
<template>
    <div class="item-position runData">
      <div class="runData-title m-b-10">
        <div>{{$t('box')}}: {{data.boxName}}</div>
        <div>Crane Information</div>
      </div>
      <div class="run-content">
        <span>{{$t('current')}}：</span>
        <span>A：{{data.currentA}}A</span>；
        <span>B：{{data.currentB}}A</span>；
        <span>C：{{data.currentC}}A</span>
      </div>
      <div class="run-content">
        <span>{{$t('leakage')}}：</span>
        <template v-for="(item,index) of data.leakagesValues">
          <span :key="`${item.num}leakage`">{{index + 1}}{{$t('branch')}}：</span>
          <span :key="item.num">{{formatter(item.leakage)}}mA</span>
          <span :key="`${item.num}mark`" v-if="index < data.leakagesValues.length - 1">；</span>
        </template>
      </div>
      <div class="run-content">
        <span>{{$t('temperature')}}：</span>
        <template v-for="(item,index) of data.temperaturesValues">
          <span :key="`${item.num}temperature`">{{index + 1}}{{$t('branch')}}：</span>
          <span :key="item.num">{{formatter(item.temperature)}}℃</span>
          <span :key="`${item.num}mark`" v-if="index < data.temperaturesValues.length - 1">；</span>
        </template>
      </div>
      <div class="run-content">
        <span>{{$t('resiValue')}}：</span>
        <span>{{data.resi}}Ω</span>；
        <span>{{$t('totalEnergy')}}：</span>
        <span>{{data.energyTotal}}{{$t('powerUnit')}}</span>
      </div>
      <div class="run-content">
        <span>{{$t('alarm')}}：</span>
        <span v-if="data.alarmList.length" :style="{color: '#eb5757'}">{{data.alarmList.join('、')}}</span>
        <span v-else>{{$t('noData')}}</span>
      </div>
    </div>
</template>

<script>
import {formatterNumber} from '@/utils/utils'
export default {
  name: 'BoxInfo',
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    formatter () {
      return (val, index) => {
        return formatterNumber(val, index)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .runData{
    background-color: rgba(4,30,48,0.5);
    width: 400px;
    height: 226px;
    left: 375px;
    top: 844px;
    padding:10px 20px;
    .runData-title{
      font-size: 13px;
      div:last-child{
        color:#5f7f9b;
      }
    }
    .run-content{
      padding: 5px 0;
      color:#49d5f3;
      font-size: 15px;
      & > span:first-child {
        color: #fff
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BoxInfo.vue